import React, { Component, PropTypes } from 'react';
import PreplanificationSelection from 'common/components/PreplanificationSelection';
import Modal from 'common/components/Modal';
import cx from 'classnames';

class SchedulingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canSubmit: props.value && props.value.length > 0,
    };

    this._onDateSelected = this._onDateSelected.bind(this);
  }

  _onDateSelected(date) {
    this.setState({
      selected: date,
      canSubmit: true,
    });
  }

  render() {
    const { value, onClosed, onSaved } = this.props;
    const { selected, canSubmit } = this.state;

    const save = () => onSaved(selected);

    const saveButtonClass = cx('ui primary labeled icon button', {
      disabled: !canSubmit,
    });

    return (
      <Modal isOpened closable onClose={onClosed}>
        <div className="header">{this.props.title || 'Pré Planification'}</div>
        <div className="content">
          <PreplanificationSelection
            value={value}
            multiSelection={true}
            onSelectionChanged={this._onDateSelected}
          />
        </div>
        <div className="actions">
          <button className={saveButtonClass} onClick={save}>
            <i className="icon save" />
            Enregistrer
          </button>
        </div>
      </Modal>
    );
  }
}

SchedulingModal.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onSaved: PropTypes.func.isRequired,
  onClosed: PropTypes.func.isRequired,
  noDelete: PropTypes.bool,
};

export default SchedulingModal;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/forced-invoices-organize/SchedulingModal.js